import Vue from 'vue'

const currencyModule = {
    state: {
        currencyList: [],
        currentCurrency: {}
    },
    mutations: {
        SET_CURRENCIES (state, newVal) {
            state.currencyList = newVal
        },
        SET_CURRENT_CURRENCY (sate, newVal) {
            state.currentCurrency = newVal
        }
    },
    getters: {
        getBindings (state) {
            return state.currentCurrency
        },
        getBinding (state) {
            return state.currentCurrency
        }
    },
    actions: {
        async FETCH_CURRENCIES (ctx) {
            let result = await Vue.API.AmfRequest(
                'frechmann.Format',
                'getAllCurrencies'
            )

            ctx.commit('SET_CURRENCIES', result.data)
        },
        async FETCH_CURRENCY (ctx, id) {
            let result = await Vue.API.AmfRequest(
                'frechmann.Format',
                'getCurrencyForId',
                id
            )

            ctx.commit('SET_CURRENT_CURRENCY', result.data)
        }
    }
}

export const state = currencyModule.state
export const getters = currencyModule.getters
export const mutations = currencyModule.mutations
export const actions = currencyModule.actions
